import { render, staticRenderFns } from "./PatentTransactionReport.vue?vue&type=template&id=26743c62&"
import script from "./PatentTransactionReport.vue?vue&type=script&lang=js&"
export * from "./PatentTransactionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports